<!-- 专题专栏 -->
<template>
  <div class="special-column">
    <div class="logo" @click="goback">
      <img src="@/assets/images/converted.png" alt="" />
      <div class="logo-text">
        <h2>广西壮族自治区医疗器械检测中心</h2>
        <p>Guangxi Testing Center for Medical Devices</p>
      </div>
  </div>
    
    
    <div v-for="item in themeList" :key="item.id">
      <h1 v-html="item.title"></h1>
    </div>
    <news-list></news-list>
  </div>
</template>
<script>
import newsList from '../../components/news/news-list.vue'
import { getThemeList } from '@/api/index'
export default {
  name: '',
  components: { newsList },
  props: [],
  data() {
    return {
      themeList: ''
    }
  },
  watch: {},
  mounted() {
    this.getThemeList()
  },
  created() {},
  methods: {
    goback() {
      this.$router.back()
    },
    getThemeList() {
      getThemeList()
        .then((res) => {
          this.themeList = res.list
        })
        .finally(() => {})
    }
  }
}
</script>

<style lang="scss" scope>
.special-column {
  width: 100%;
  padding-top: 54px;
  .logo {
    display: flex;
    height: 108px;
    align-items: center;
    margin-bottom: 30px;
    cursor: pointer;
      img {
        height: 100%;
      }
      .logo-text {
        margin-left: 20px;
        h2 {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 800;
          font-size: 35px;
          color: #FFF;
        }
        
        p {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: bold;
          font-size: 21px;
          color: #FFF;
          line-height: 37px;
          letter-spacing: 2px;
        }
      }  
  }
  .news-list {
    border-radius: 10px;
    background: url(../../assets/images/list_bg.webp) no-repeat;
    background-size: 100% 100%;
  }

  @font-face {
    font-family: 'Ultra';
    src: url(../../assets/css/PangMenZhengDaoBiaoTiTi-1.ttf);
  }

  h1 {
    margin-bottom: 40px;
    line-height: 70px;
    font-size: 55px;
    line-height: 70px;
    letter-spacing: 2px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    background: linear-gradient(90.00000000000479deg, #fff8e8 0%, #ffd062 100%);
    background: linear-gradient(to bottom, #fff8e8, #ffd062); /* 渐变色 */
    -webkit-background-clip: text; /* WebKit 浏览器 */
    background-clip: text;
    color: transparent;
  }
  .news-list {
    margin-bottom: 40px;
  }
}
@media screen and (max-width: 768px) {
  .special-column {
    padding-top: 28px;
    .logo {
      height: auto;
      width: 260px;
      margin-bottom: 16px;
      img {
        width: 100%;
      }
    }
    h1 {
      font-size: 20px;
      line-height: 1.2;
      margin-bottom: 16px;
    }
  }
}
</style>
